import { render, staticRenderFns } from "./TheCardDrawer.vue?vue&type=template&id=36d9a2cc&"
import script from "./TheCardDrawer.vue?vue&type=script&lang=ts&"
export * from "./TheCardDrawer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports